import { animated, useTransition } from '@react-spring/web'
import { useAtom } from 'jotai'

import { notificationAtom } from '@/lib/state/notification'

const Notification: React.FC = () => {
    const [notification, setNotification] = useAtom(notificationAtom)
    const transaction = useTransition(notification, {
        from: { opacity: 0, height: 0, life: '100%' },
        enter: { opacity: 1, height: 'auto', life: '0%' },
        leave: { opacity: 0, height: 0 },
        config: { duration: 5000, tension: 125, friction: 20, precision: 0.1 },
        onRest: () => {
            setNotification(null)
        },
    })

    if (!notification) return null

    return transaction(({ life, ...style }, it) => {
        if (!it) return null
        return (
            <animated.div style={style} className="fixed right-3 top-3 z-50">
                <div
                    className="relative h-auto  w-[400px] rounded border bg-red-100 px-4 py-3 text-red-700"
                    role="alert"
                >
                    <span className="block sm:inline">{it.message}</span>
                    <button
                        className="absolute inset-y-0 right-0 px-4 py-3"
                        onClick={() => setNotification(null)}
                    >
                        <svg
                            className="h-6 w-6 fill-current text-red-500"
                            role="button"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                        >
                            <title>Close</title>
                            <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                        </svg>
                    </button>
                    <animated.div
                        className="absolute bottom-0 left-0 h-[5px] bg-red-700"
                        style={{ right: life as any }}
                    ></animated.div>
                </div>
            </animated.div>
        )
    })
}

export default Notification
